import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyD82PA03Qylq5vmZK61rEkbUAOi8qNjsaE",
//   authDomain: "coded-plus.firebaseapp.com",
//   projectId: "coded-plus",
//   storageBucket: "coded-plus.firebasestorage.app",
//   messagingSenderId: "219667843411",
//   appId: "1:219667843411:web:8c565dc298185a695739a6"
// };

// const firebaseConfig = {
//   "apiKey": "AIzaSyDzDToEC2pjltUhuAU_1Ea1iXZ61sQex4w",
//   "authDomain": "coded-plus-2025.firebaseapp.com",
//   "projectId": "coded-plus-2025",
//   "storageBucket": "coded-plus-2025.firebasestorage.app",
//   "messagingSenderId": "973352712301",
//   "appId": "1:973352712301:web:9f9f16584268af5b5ee764"
// }

const firebaseConfig = {
  "apiKey": "AIzaSyBbKdFaufcfA5IG-fyAbf69lwewUViAe0g",
  "authDomain": "codedplus-25.firebaseapp.com",
  "projectId": "codedplus-25",
  "storageBucket": "codedplus-25.firebasestorage.app",
  "messagingSenderId": "246396851407",
  "appId": "1:246396851407:web:8a52447fee6ebf22d113ba"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
export const auth = getAuth();

export default app;